import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { isProd } from "./utils/EnvironmentUtils";

const reactPlugin = new ReactPlugin();
let appInsights = null;

function loadApplicationInsights(reactPlugin, appInsights) {
  console.log("AppInsights.js carregado");

  const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

  console.log("Debug Application Insights:");
  console.log("- Connection String existe?", !!connectionString);
  console.log("- Connection String length:", connectionString.length || 0);
  console.log("- NODE_ENV:", process.env.NODE_ENV);

  // Mostrar todas as variáveis REACT_APP_*
  const reactAppVars = Object.keys(process.env).filter((key) =>
    key.startsWith("REACT_APP_"),
  );
  console.log("- Variáveis REACT_APP_ disponíveis:", reactAppVars);

  if (!connectionString || connectionString.length === 0) {
    console.error("ERRO: Connection String não está configurada!");
    console.error(
      "Verifique se o arquivo .env.development existe na raiz do projeto",
    );
    console.error("E se contém: REACT_APP_APPINSIGHTS_CONNECTION_STRING=...");

    // Criar instância vazia para não quebrar o código
    appInsights = {
      loadAppInsights: () => console.warn("App Insights não configurado"),
      trackEvent: () => console.warn("App Insights não configurado"),
      trackPageView: () => console.warn("App Insights não configurado"),
      trackException: () => console.warn("App Insights não configurado"),
      trackTrace: () => console.warn("App Insights não configurado"),
      trackMetric: () => console.warn("App Insights não configurado"),
    };
  } else {
    console.log("Connection String encontrada, inicializando...");

    appInsights = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableFetchTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
      },
    });

    try {
      appInsights.loadAppInsights();
      console.log("Application Insights inicializado com sucesso!");

      // Expor globalmente
      window.appInsights = appInsights.appInsights;
      console.log("window.appInsights disponível:", !!window.appInsights);

      // Enviar evento de teste
      appInsights.trackEvent({
        name: "AppInsightsInitialized",
        properties: {
          timestamp: new Date().toISOString(),
          environment: process.env.NODE_ENV,
        },
      });
      console.log("Evento de inicialização enviado");
    } catch (error) {
      console.error("Erro ao inicializar Application Insights:", error);
    }
  }
  return reactPlugin;
}

if (isProd()) loadApplicationInsights(reactPlugin, appInsights);

export { reactPlugin, appInsights };
